import { useEffect } from 'react';

import type { RefObject } from 'react';

const useResizeObserver = <T extends Element>(
  ref: RefObject<T | null>,
  callback: (entries: ResizeObserverEntry[]) => void,
  enabled = true
) => {
  useEffect(() => {
    if (!enabled) return;
    const element = ref.current;
    if (!element) return;

    let rafId = 0;
    const observer = new ResizeObserver((entries) => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => callback(entries));
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
      cancelAnimationFrame(rafId);
    };
  }, [ref, enabled, callback]);
};

export default useResizeObserver;
